import React from 'react'

import { MdCancel } from 'react-icons/md'

export default function NoPickableResult ({ ...props })
{
	return (
		<li className="c-model-picker__item">
			<span className="c-model-picker__no-result" data-empty={ props.empty }>
				<MdCancel
					className="c-model-picker__no-result-icon"
				/>
				{
					props['empty']
					? 'Recherchez quelque chose'
					: 'Aucun résultat.'
				}
			</span>
		</li>
	);
}